<template>
  <div class="add-expense">
    <colored-popup class="primary" :darkText="false" :close-action="close">
      <template v-slot:top-content>
        <div class="title">הוספת הוצאה</div>
      </template>
      <template v-slot:bottom-content>
        <div class="description">
          <div>
  כמה הוצאת על           <span class="bold">אוכל בחוץ?</span>
          </div>
          <div>עדכון יומי יעזור לך ולקבוצה להגיע ליעד.</div>
        </div>
        <div class="input">
          <div class="title">היום הוצאתי</div>
          <amount-input v-model="dailyAmount" label=""/>
          <riseup-button title="עדכן סכום הוצאה" variant="primary" size="slim" :action="addExpense"/>
        </div>
        <div class="join-riseup">
          <div class="description">היי, עם רייזאפ ההוצאות שלך יתעדכנו באופן אוטומטי. תקופת הנסיון היא בחינם.</div>
          <riseup-button title="הצטרפות לרייזאפ" variant="secondary" size="slim" :action="join"/>
        </div>
      </template>
    </colored-popup>

  </div>
</template>

<script>

import BaseUI from 'base-ui';
import { mapActions } from 'vuex';
import router from '@/router';

export default {
  name: 'AddExpense',
  components: {
    AmountInput: BaseUI.AmountInput,
    ColoredPopup: BaseUI.ColoredPopup,
    RiseupButton: BaseUI.RiseupButton,
  },
  data() {
    return {
      dailyAmount: 0,
    };
  },
  methods: {
    ...mapActions('modalRootStore', ['closeModal']),
    ...mapActions('accountabilityChallenge', ['updateParticipantSpent']),
    addExpense() {
      this.updateParticipantSpent(this.dailyAmount);
      this.close();
    },
    close() {
      this.closeModal();
    },
    join() {
      router.push({ path: '/signup' });
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';

  .add-expense {
    text-align: right;
    .title {
      font-weight: bold;
      font-size: 22px;
      color: $riseup_white;
    }
    .description {
      font-size: 18px;
      .bold {
        font-weight: bold;
      }
    }
    .input {
      width: 100%;
      color: $riseup-black;
      .title {
        margin: 11px 0 0;
        color: $riseup_blue;
        font-size: 14px;
        text-align: right;
      }
    }
    .join-riseup {
      font-size: 18px;
      text-align: center;
      .description {
        margin: 36px 24px 24px;
      }
    }
  }

</style>
